import { Box, Dialog, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { OrgLogoCommandDto } from "../../../api/models/schema";
import { UploadImageButton } from "../../../common/uploadImageButton";
import { OrganizationContext } from "../../../context/organizationContext";


export interface UpdateLogoFormProps {
  open: boolean;
  onClose: () => void;
  onUpdate: (logoImage:OrgLogoCommandDto) => void;
}

export function UpdateLogoForm(props: UpdateLogoFormProps) {

  const [newLogo, setNewLogo] = useState('');
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { errorMessage} = useContext(OrganizationContext);

  useEffect(() => {
    if (props.open) {
      setIsLoading(false);
    }
  }, [props.open]);


  const onChangeLogo = async (selectedImage: string): Promise<void> => {
    setNewLogo(selectedImage);
}

  function submitForm() {
    if(newLogo){

      const OrgLogoCommandDto: OrgLogoCommandDto = {
        image: newLogo,
      };
      setIsLoading(true);
      props.onUpdate(OrgLogoCommandDto);
    }
    else{
      setError('Please select a logo');
    }
  }

  function handleClose() {
    setNewLogo('');
    props.onClose();
  }


  function displayForm() {
    return (
      <Box>
        <Dialog open={props.open}>
          <DialogTitle>Update Logo</DialogTitle>
          <DialogContent>

          {!newLogo && <UploadImageButton id="uploadProfile" onChange={onChangeLogo} aspectRatio={1} />}
          {newLogo && <img src={newLogo} alt="logo" />}
          <br/>
           
          <Grid container spacing={2}>
                    <Grid
                      spacing={2}
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                    >
                      {!isLoading && (
                        <Grid item>
                          <Button variant="contained" onClick={submitForm}>
                            Save
                          </Button>
                        </Grid>
                      )}
                      {isLoading && (
                        <Grid item>
                          <CircularProgress />
                        </Grid>
                      )}

                      <Grid item>
                        <Button onClick={handleClose}>Cancel</Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {errorMessage && <p>errorMessage</p>}
                      {error && <p>error</p>}
                    </Grid>
                  </Grid>
                
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return <>{displayForm()}</>;
}
